export const formatJdToHtml = (content) => {
  if (!content) return "";

  const headings = [
    "Preferred Qualifications",
    "Key Responsibilities",
    "Job Responsibilities",
    "Required Skills",
    "Key Requirements",
    "About the Role",
    "What We Offer",
    "Responsibilities",
    "Requirements",
    "Qualifications",
    "Skills",
  ].sort((a, b) => b.length - a.length);

  const escapeHtml = (text) => {
    const div = document.createElement("div");
    div.textContent = text;
    return div.innerHTML;
  };

  const escapeRegex = (text) =>
    text.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

  const headingAlternatives = headings
    .map(escapeRegex)
    .join("|");

  let text = String(content);

  
  
  

  text = text
    .replace(/<\/stro\b[^>]*>?/gi, "")
    .replace(/<stro\b[^>]*>/gi, "")
    .replace(/<\/stron\b[^>]*>?/gi, "")
    .replace(/<stron\b[^>]*>/gi, "");

  if (/<[a-z][\s\S]*>/i.test(text)) {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = text;

    tempDiv.querySelectorAll("li").forEach((li) => {
      li.insertBefore(
        document.createTextNode("• "),
        li.firstChild
      );
    });

    tempDiv.querySelectorAll("br").forEach((br) => {
      br.replaceWith("\n");
    });

    tempDiv
      .querySelectorAll(
        "p, div, h1, h2, h3, h4, h5, h6, ul, ol, li"
      )
      .forEach((element) => {
        element.appendChild(
          document.createTextNode("\n")
        );
      });

    text = tempDiv.textContent || "";
  }
  text = text
    .replace(/\u00a0/g, " ")
    .replace(/\r\n/g, "\n")
    .replace(/\r/g, "\n")
    .replace(/[●▪◦]/g, "•");
  text = text.replace(
    /\s*•\s*/g,
    "\n• "
  );

  text = text.replace(
    new RegExp(
      `\\s+(${headingAlternatives})\\s*:?\\s*$`,
      "gmi"
    ),
    "\n$1"
  );

  text = text.replace(
    new RegExp(
      `(${headingAlternatives})\\s*(?=•)`,
      "gi"
    ),
    "$1\n"
  );

  text = text.replace(/\n{3,}/g, "\n\n");

  const lines = text
    .split("\n")
    .map((line) => line.trim())
    .filter(Boolean);

  const output = [];

  const exactHeadingRegex = new RegExp(
    `^(${headingAlternatives})\\s*:?$`,
    "i"
  );

  for (const line of lines) {
    
    if (/^(?:•|[-*])\s+/.test(line)) {
      const bulletText = line
        .replace(/^(?:•|[-*])\s+/, "")
        .trim();

      if (bulletText) {
        output.push({
          type: "bullet",
          value: bulletText,
        });
      }

      continue;
    }

    
    
    

    const exactHeadingMatch =
      line.match(exactHeadingRegex);

    if (exactHeadingMatch) {
      output.push({
        type: "heading",
        value: exactHeadingMatch[1],
      });

      continue;
    }


    let headingFound = false;

    for (const heading of headings) {
      const regex = new RegExp(
        `^${escapeRegex(heading)}(?:\\s*:\\s*|\\s+)(.+)$`,
        "i"
      );

      const match = line.match(regex);

      if (!match) continue;

      const remaining = match[1].trim();

      if (!remaining) continue;

      output.push({
        type: "heading",
        value: heading,
      });

      output.push({
        type: "text",
        value: remaining,
      });

      headingFound = true;
      break;
    }

    if (headingFound) continue;

    output.push({
      type: "text",
      value: line,
    });
  }

  let html = "";
  let bulletItems = [];

  const flushBullets = () => {
    if (!bulletItems.length) return;

    html += "<ul>";

    bulletItems.forEach((item) => {
      html += `<li>${escapeHtml(item)}</li>`;
    });

    html += "</ul>";

    bulletItems = [];
  };

  output.forEach((item) => {
    if (item.type === "bullet") {
      bulletItems.push(item.value);
      return;
    }

    flushBullets();

    if (item.type === "heading") {
      html += `<h3>${escapeHtml(item.value)}</h3>`;
      return;
    }

    if (item.type === "text") {
      html += `<p>${escapeHtml(item.value)}</p>`;
    }
  });

  flushBullets();

  return html;
};